import { UserInterface } from "../../models/UserModel/User";
import { ForgetPasswordInterface } from "../../domain/helpers/ForgetPassword";
import client from "../client";

class UserService {
  async GetAll(page: number, pageSize: number) {
    try {
      let url = `/api/Users`;
      let dataHeader = {};
      if (page > 0 && pageSize > 0) {
        dataHeader = { page, pageSize };
      }
      const { data } = await client.post<UserInterface[]>(url, dataHeader);
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
  async GetRoles() {
    try {
      let url = `/api/Users/Roles`;
      const { data } = await client.get<string[]>(url);
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
  async GetByFirstlastName(
    page: number,
    pageSize: number,
    searchTerm: string
  ): Promise<UserInterface[]> {
    try {
      let url = `/api/Users`;
      const [name, ...lastname] = searchTerm.trim().split(/\s+/);
      let result: {
        firstname: string;
        lastname: string;
        page: number;
        pageSize: number;
        excludeAdmins: boolean;
      } = {
        firstname: "",
        lastname: "",
        page,
        pageSize,
        // excludeAdmins: excludeAdmins && excludeAdmins === true ? true : false,
        excludeAdmins: false,
      };
      if (lastname.length) {
        result.firstname = name;
        result.lastname = lastname.join(" ");
      } else {
        result.firstname = name;
      }

      const { data } = await client.post<UserInterface[]>(url, result);

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
  async GetByEmail(email: string) {
    try {
      let url = `/api/Users`;

      const { data } = await client.post<UserInterface>(url, { email });

      return data[0];
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
  async GetById(id: string) {
    try {
      let url = `/api/Users`;

      const { data } = await client.post<UserInterface>(url, { id });
      console.log("result", data);

      return data[0];
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async GetUsersWithPasswordForget(page: number, pageSize: number) {
    try {
      let url = `/api/Users/UsersWithPasswordForget`;

      const { data } = await client.post<ForgetPasswordInterface[]>(url, {
        page,
        pageSize,
      });

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async ResetPassword(
    email: string,
    password: string
  ): Promise<ForgetPasswordInterface> {
    try {
      let url = `/api/Users/ResetPassword`;
      const response = await client.post<ForgetPasswordInterface>(url, {
        email,
        password,
      });
      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async Save(user: UserInterface) {
    try {
      let url = `/api/Users/AddTenantUser`;

      const { data } = await client.post<UserInterface>(url, user);

      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async Update(user: UserInterface, firstTimeLogin?: boolean) {
    try {
      const { firstname, lastname, email, roles, isActive } = user;
      let url = `/api/Users/UpdateUser`;

      let formData: any = {
        firstname,
        lastname,
        email,
        roles,
        isActive,
      };
      if (firstTimeLogin !== undefined) {
        formData.FirstTimeLogin = false;
      }

      const { data } = await client.post<UserInterface>(url, formData);

      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
  async Remove(id: string) {
    try {
      let url = `api/Users/remove/${id}`;
      await client.post<UserInterface>(url, { url: "" });
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
}

export default new UserService();
